import { VARIANTS, attackSituation } from './attack';

/** 攻撃宣言の後に、攻撃されたモンスターが裏から表になったか（窓はその攻撃宣言まで。ダメージステップでめくれた裏守備など） */
export function targetFlipped(payload, history) {
  const uid = payload?.target?.uid;
  if (!uid) return false;
  return Boolean(history?.last?.('pos_change', {
    until: ['attack', 'new_phase', 'new_turn'],
    filter: (p) => p?.uid === uid && p?.prevPosition?.faceUp === false && p?.position?.faceUp === true,
  }));
}

/**
 * **ダメージ計算**（Issue #589）。攻撃宣言と同じ分け方（`direct` / `monster`）と事実。
 * 足す事実: `targetFlipped`（攻撃宣言の後に対象が裏から表になった＝攻撃宣言のときは裏だった。Issue #961。
 * 盤面はもう表なので `target.faceUp` では分からない）
 */
export default Object.freeze({
  event: 'battle',
  variants: VARIANTS,
  classify({ payload, board, history }) {
    const out = attackSituation({ payload, board });
    return out ? { ...out, targetFlipped: targetFlipped(out, history) } : null;
  },
});
